<div *ngIf="exibirLoader">
  <app-loader></app-loader>
</div>

<lovers-login-popup [exibir]="exibePopupGenerico" (onClose)="exibePopupGenerico = false" tamanho="grande">
  <div class="popup__header">
    <p class="header__title">{{ tituloModalGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <label class="mb-0">
        <span *ngFor="let item of descricaoModalGenerico" [innerHtml]="item">
        </span>
      </label>
    </div>
  </div>
</lovers-login-popup>

<app-cadastro-chat [hidden]="exibirCadastro"></app-cadastro-chat>

<main id="home" class="lovers__home">
  <div class="home__programa">
    <img class="programa__logo" src="assets/images/logos/cacau_lovers_seu_jeito.png" alt="Cacau Lovers" />
    <div class="programa__descricoes">
      <p class="programa__saudacao">
        Oi <span class="lovers-font--bold">Crush</span>,
      </p>
      <p class="programa__descricao">
        Que bom saber que você também é
        <span class="lovers-font--bold">apaixonado por chocolate</span>.
      </p>
      <p class="programa__descricao">
        <span class="lovers-font--bold">Cacau Lovers</span> é o programa de
        fidelidade da Cacau Show que
      </p>
      <p class="programa__descricao">
        foi feito com muito carinho para que seja do
        <img class="descricao__seu__jeito" src="assets/images/logos/seu_jeito.png" />
      </p>
    </div>
    <div class="programa__beneficios">
      <div class="beneficios__beneficio">
        <img class="beneficio__imagem" src="assets/images/icons/precos_exclusivos.png" />
        <p class="beneficio__descricao">Preços Exclusivos</p>
        <p class="beneficio__descricao">
          com <span class="lovers-font--bold">CashJá</span>
        </p>
      </div>
      <div class="beneficios__beneficio">
        <img class="beneficio__imagem" src="assets/images/icons/promocoes.png" />
        <p class="beneficio__descricao">Promoções</p>
        <p class="beneficio__descricao">
          <span class="lovers-font--bold">Imperdíveis</span>
        </p>
      </div>
      <div class="beneficios__beneficio">
        <img class="beneficio__imagem" src="assets/images/icons/resgate_cacau.png" />
        <p class="beneficio__descricao">
          <span class="lovers-font--bold">1 Cacau</span> a cada
        </p>
        <p class="beneficio__descricao">R$20,00</p>
      </div>
      <div class="beneficios__beneficio">
        <img class="beneficio__imagem" src="assets/images/icons/experiencias.png" />
        <p class="beneficio__descricao">
          <span class="lovers-font--bold">Experiências</span>
        </p>
        <p class="beneficio__descricao">Inesquecíveis</p>
      </div>
    </div>
    <div class="programa__descricoes">
      <p class="programa__descricao">
        <span class="lovers-font--bold">E muito mais!</span> Falta pouco para
        você aproveitar todas as
      </p>
      <p class="programa__descricao">
        vantagens de ser um Cacau Lover, faça seu cadastro.
      </p>
      <p class="programa__descricao descricao__ajuda" (click)="irParaAtendimento()">
        Precisa de ajuda? Clique aqui
      </p>
    </div>
  </div>
  <div class="home__sidebar">
    <div class="sidebar__acesso" *ngIf="exibirAcesso">
      <form class="acesso__form" novalidate [formGroup]="acessoForm" (submit)="acessar()">
        <div class="form__somos">
          <div class="somos__contador">
            <p class="contador__valor" *ngFor="let contador of quantidadeLovers"
              [ngClass]="{ 'valor--separador': contador.tipo === 'separador' }">
              {{ contador.valor }}
            </p>
          </div>
          <div class="somos__lovers">
            <img class="lovers__logo" src="assets/images/logos/lovers.png" />
          </div>
        </div>
        <p class="form__bem__vindo">Bem-vindo, vamos entrar!</p>

        <div class="form__erro__login" *ngIf="mensagemLogin !== ''">
          <p class="erro__login__mensagem" [innerHTML]="mensagemLogin | boldColor"></p>
        </div>

        <div class="lovers-input__container">
          <label for="" class="lovers-label">E-mail ou CPF</label>
          <input type="text" class="lovers-input" formControlName="cpf" placeholder="Digite seu e-mail ou cpf" />
          <!-- <input
            type="text"
            class="lovers-input"
            pattern="[0-9]*"
            inputmode="numeric"
            mask="000.000.000-00"
            placeholder="___.___.___-__"
            formControlName="cpf"
          /> -->
        </div>

        <div class="lovers-input__container">
          <label for="" class="lovers-label">Senha</label>
          <input [type]="tipoCampoSenha ? 'text' : 'password'" class="lovers-input" placeholder="************"
            formControlName="senha" />
          <div class="text-right">
            <img class="opcao__icone mr-3 icone_visibilidade_senha" style="top: -36px" [src]="iconeSenha"
              (click)="trocarTipoCampoSenha(CAMPO_SENHA, iconeSenha)" />
          </div>
        </div>

        <p class="form__esqueci" (click)="irParaEsqueciSenha()">
          Esqueci minha senha
        </p>

        <button class="lovers-button" [disabled]="!acessoForm.valid || entrando"
          [ngClass]="{ 'lovers--disabled': !acessoForm.valid || entrando }">
          Entrar
          <i *ngIf="entrando" class="fa fa-spinner fa-spin"></i>
        </button>

        <p class="form__cadastro" (click)="irParaCadastro()">
          Ainda não é um Cacau Lover? Cadastre-se!
        </p>
      </form>
    </div>

    <div class="sidebar__cadastro" *ngIf="exibirCadastro">
      <form class="cadastro__form" novalidate [formGroup]="cadastroForm" (submit)="cadastrar()">
        <header class="form__header">
          <p class="header__voltar__acesso" (click)="irParaAcesso()">
            <svg class="voltar__icone" width="12" height="20" viewBox="0 0 12 20" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M10 2L2 10L10 18" stroke="white" stroke-width="3" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            Voltar
            {{ etapaCadastro === 1 || etapaCadastro === 6 ? "para login" : "" }}
          </p>
          <p class="header__cadastro" [hidden]="etapaCadastro === 6">
            Cadastro
          </p>
        </header>

        <div class="etapa__0" [hidden]="etapaCadastro !== 1">
          <p>Você ainda não é um Cacau Lover?</p>
          <p>Vamos iniciar nosso relacionamento!</p>
          <p>Só precisamos de alguns dados, é rapidinho.</p>

          <div class="lovers-input__container">
            <label for="" class="lovers-label">CPF</label>
            <input type="text" class="lovers-input" pattern="[0-9]*" inputmode="numeric" placeholder="___.___.___-__"
              formControlName="cpf" mask="000.000.000-00" />
          </div>
        </div>

        <div class="etapa__1" [hidden]="etapaCadastro !== 2">
          <p class="nome">Por favor, informe seu nome e sobrenome</p>

          <div class="lovers-input__container">
            <label for="" class="lovers-label">Nome</label>
            <input type="text" class="lovers-input" placeholder="Digite o seu nome" formControlName="nome" />
          </div>

          <div class="lovers-input__container">
            <label for="" class="lovers-label">Sobrenome</label>
            <input type="text" class="lovers-input" placeholder="Digite seu sobrenome" formControlName="sobrenome" />
          </div>
        </div>

        <div class="etapa__2" [hidden]="etapaCadastro !== 3">
          <p class="data__nascimento">Qual é a sua data de nascimento?</p>
          <div class="lovers-input__container">
            <label for="" class="lovers-label">Data de nascimento</label>
            <input type="text" class="lovers-input" pattern="[0-9]*" inputmode="numeric" placeholder="dd/mm/aaaa"
              mask="00/00/0000" formControlName="dataNascimento" (change)="validarDataNascimento($event)" />
          </div>

          <div *ngIf="precisaAprovador" class="lovers-input__container">
            <p class="data__nascimento">CPF do responsável?</p>

            <div class="lovers-input__container">
              <label for="" class="lovers-label">CPF do responsável</label>
              <input type="text" class="lovers-input" pattern="[0-9]*" inputmode="numeric" mask="000.000.000-00"
                placeholder="___.___.___-__" formControlName="cpfResponsavel" />
            </div>
          </div>
        </div>

        <div class="etapa__3" [hidden]="etapaCadastro !== 4">
          <p class="info__contato">Quais as suas informações de contato?</p>

          <div class="lovers-input__container">
            <label for="" class="lovers-label">E-mail</label>
            <input type="text" class="lovers-input" placeholder="cacaulover@email.com" formControlName="email" />
          </div>

          <div class="lovers-input__container">
            <label for="" class="lovers-label">Celular</label>
            <input type="text" class="lovers-input" pattern="[0-9]*" inputmode="numeric" placeholder="(00) 00000-0000"
              mask="(00) 00000-0000" formControlName="celular" />
          </div>
        </div>

        <div class="etapa__4" [hidden]="etapaCadastro !== 5">
          <p class="senha">Cadastre sua senha</p>

          <div class="lovers-input__container">
            <label for="" class="lovers-label">Senha</label>
            <input type="password" class="lovers-input" placeholder="************" formControlName="senha"
              (keyup)="validarClasseValidacaoSenha()" />
          </div>
          
          <app-validete-password [valuePassword]="cadastroForm.controls['senha'].value" (passwordValidate)="valuePassword($event)"></app-validete-password>

          <div class="lovers-input__container">
            <label for="" class="lovers-label">Confirme sua senha</label>
            <input type="password" class="lovers-input" placeholder="************" formControlName="confirmarSenha" />
          </div>

          <div class="lovers-checkbox__container">
            <input type="checkbox" name="termos" id="termos" formControlName="aceiteTermos" />
            <label class="" for="termos">
              Li e aceito os
              <span (click)="mostrarPopupTermos()">termos</span> e
              <span (click)="mostrarPopupRegulamento()">condições</span> do
              Programa Cacau Lovers
            </label>
          </div>
        </div>

        <div class="etapa__5" [hidden]="etapaCadastro !== 6">
          <img src="assets/images/others/cadastro_lover.gif" class="cadastro__confete" />

          <img class="lovers__image" src="assets/images/others/novo_lover.png" alt="Cadastro Realizado" />

          <div *ngIf="!precisaAprovador">
            <p class="parabens">Parabéns Crush!</p>
            <p class="acesse">
              Agora você pode entrar na sua conta e aproveitar todas as
              vantagens!
            </p>
          </div>

          <div *ngIf="precisaAprovador">
            <p class="parabens">Parabéns Crush!</p>
            <p class="acesse">
              Agora seu responsável precisa aprovar seu cadastro!
            </p>
          </div>
        </div>

        <div class="form__continuar" [hidden]="etapaCadastro >= 5">
          <button class="lovers-button" type="button" (click)="irParaEtapa(etapaCadastro + 1)"
            [disabled]="buscandoMembro" [ngClass]="{ 'lovers--disabled': buscandoMembro }">
            Continuar
            <i *ngIf="buscandoMembro" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>

        <div class="form__continuar" [hidden]="etapaCadastro !== 5">
          <button class="lovers-button" [disabled]="!cadastroForm.valid || cadastrando" [ngClass]="{
              'lovers--disabled': !cadastroForm.valid || cadastrando
            }">
            Cadastrar
            <i *ngIf="cadastrando" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>

        <div class="form__acessar" [hidden]="etapaCadastro !== 6" *ngIf="!precisaAprovador">
          <button class="lovers-button cadastro__entrar__btn" type="button" (click)="acessar()" [disabled]="entrando"
            [ngClass]="{ 'lovers--disabled': entrando }">
            Entrar
            <i *ngIf="entrando" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>

        <div class="form__etapas" [hidden]="etapaCadastro === 6">
          <div class="etapas__etapa" *ngFor="let etapa of etapas"
            [ngClass]="{ 'etapa--atual': etapa === etapaCadastro }"></div>
        </div>
      </form>
    </div>
  </div>
  <div class="home__background">
    <img src="assets/images/backgrounds/radial_red.png" alt="" class="background__image" />
  </div>
</main>